/* ==========================================================================
   VICTORY PATH — vp-hero3d.js
   Spiritual chakra hero (canvas, no library):
     • rotating 3D sacred-geometry sphere (chakra-coloured vertices + edges)
     • slow lotus mandala rings
     • 7 orbiting chakra energy orbs
     • rising chakra light motes
   Everything tilts toward cursor / finger. Blends over the page.
   Pauses when off-screen or the tab is hidden (performance).
   ========================================================================== */
(function () {
  'use strict';

  var CHAKRA = [
    [226, 62, 62],   // root - red
    [242, 135, 62],  // sacral - orange
    [242, 209, 62],  // solar - yellow
    [87, 200, 77],   // heart - green
    [62, 166, 242],  // throat - blue
    [108, 92, 231],  // third eye - indigo
    [168, 85, 230]   // crown - violet
  ];
  function rgba(c, a) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }

  function init() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var host = hero.querySelector('.hero__bg-fallback');
    if (!host) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var canvas = document.createElement('canvas');
    canvas.className = 'vp-hero-canvas';
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;';
    host.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, CX = 0, CY = 0, R = 0;
    function resize() {
      var r = host.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = Math.max(1, W * DPR); canvas.height = Math.max(1, H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      CX = W * 0.5; CY = H * 0.46; R = Math.min(W, H) * 0.34;
    }
    resize(); window.addEventListener('resize', resize);

    var mx = 0.5, my = 0.5, tmx = 0.5, tmy = 0.5;
    function onMove(cx, cy) { tmx = cx / window.innerWidth; tmy = cy / window.innerHeight; }
    window.addEventListener('mousemove', function (e) { onMove(e.clientX, e.clientY); });
    window.addEventListener('touchmove', function (e) { if (e.touches[0]) onMove(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });

    // 3D fibonacci sphere
    var N = 110, pts = [];
    for (var i = 0; i < N; i++) {
      var tt = i / (N - 1);
      var inc = Math.acos(1 - 2 * tt);
      var az = i * 2.399963229;
      pts.push({ x: Math.sin(inc) * Math.cos(az), y: Math.cos(inc), z: Math.sin(inc) * Math.sin(az), c: CHAKRA[i % 7] });
    }

    // rising light motes
    var motes = [];
    function seedMote() {
      return { x: Math.random() * W, y: H + Math.random() * H, vy: -(0.15 + Math.random() * 0.5),
        vx: (Math.random() - 0.5) * 0.2, r: 1 + Math.random() * 3, c: CHAKRA[(Math.random() * 7) | 0],
        a: 0.15 + Math.random() * 0.35, ph: Math.random() * 6.28 };
    }
    for (var m = 0; m < 70; m++) { motes.push(seedMote()); motes[m].y = Math.random() * H; }

    var rotX = 0, rotY = 0, autoY = 0;

    function mandala(t) {
      for (var ring = 0; ring < 3; ring++) {
        var petals = 12 + ring * 4;
        var rad = R * (0.52 + ring * 0.26);
        var rot = t * (ring % 2 === 0 ? 0.12 : -0.16) + ring;
        var col = CHAKRA[(Math.floor(t * 0.4) + ring) % 7];
        ctx.save(); ctx.translate(CX, CY); ctx.rotate(rot);
        ctx.strokeStyle = rgba(col, 0.16 + 0.05 * Math.sin(t + ring));
        ctx.lineWidth = 1;
        for (var p = 0; p < petals; p++) {
          var a = (p / petals) * Math.PI * 2;
          var x = Math.cos(a) * rad, y = Math.sin(a) * rad;
          var nx = Math.cos(a) * rad * 0.6, ny = Math.sin(a) * rad * 0.6;
          ctx.beginPath();
          ctx.moveTo(0, 0);
          ctx.quadraticCurveTo(nx - Math.sin(a) * rad * 0.18, ny + Math.cos(a) * rad * 0.18, x, y);
          ctx.quadraticCurveTo(nx + Math.sin(a) * rad * 0.18, ny - Math.cos(a) * rad * 0.18, 0, 0);
          ctx.stroke();
        }
        ctx.restore();
      }
    }

    function sphere(t) {
      var ry = rotY + autoY, rx = rotX;
      var cy = Math.cos(ry), sy = Math.sin(ry), cx = Math.cos(rx), sx = Math.sin(rx);
      var proj = [];
      for (var i = 0; i < N; i++) {
        var p = pts[i];
        var x = p.x * cy - p.z * sy;
        var z = p.x * sy + p.z * cy;
        var y = p.y * cx - z * sx;
        z = p.y * sx + z * cx;
        var persp = 1 / (1.9 - z * 0.7);
        proj.push({ x: CX + x * R * persp, y: CY + y * R * persp, z: z, s: persp, c: p.c });
      }
      // edges
      ctx.lineWidth = 0.7;
      for (var a = 0; a < N; a++) {
        for (var b = a + 1; b < a + 6 && b < N; b++) {
          var A = proj[a], B = proj[b];
          var dx = A.x - B.x, dy = A.y - B.y, d2 = dx * dx + dy * dy;
          if (d2 < R * R * 0.16) {
            var al = (1 - d2 / (R * R * 0.16)) * 0.28 * (((A.z + B.z) * 0.5 + 1) * 0.5);
            ctx.strokeStyle = rgba(A.c, al);
            ctx.beginPath(); ctx.moveTo(A.x, A.y); ctx.lineTo(B.x, B.y); ctx.stroke();
          }
        }
      }
      // vertices
      for (var v = 0; v < N; v++) {
        var q = proj[v]; var depth = (q.z + 1) * 0.5;
        var rr = (0.8 + depth * 2.6) * q.s, al2 = 0.25 + depth * 0.7;
        var g = ctx.createRadialGradient(q.x, q.y, 0, q.x, q.y, rr * 3);
        g.addColorStop(0, rgba(q.c, al2)); g.addColorStop(1, rgba(q.c, 0));
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(q.x, q.y, rr * 3, 0, 6.283); ctx.fill();
        ctx.fillStyle = rgba(q.c, Math.min(1, al2 + 0.2)); ctx.beginPath(); ctx.arc(q.x, q.y, rr, 0, 6.283); ctx.fill();
      }
    }

    function orbs(t) {
      for (var i = 0; i < 7; i++) {
        var a = t * 0.25 + (i / 7) * Math.PI * 2;
        var rad = R * 1.32;
        var x = CX + Math.cos(a) * rad * 1.15;
        var y = CY + Math.sin(a) * rad * 0.7 + Math.sin(t * 1.2 + i) * 6;
        var pulse = 0.7 + 0.3 * Math.sin(t * 1.6 + i);
        var rr = R * 0.07 * pulse;
        var c = CHAKRA[i];
        var g = ctx.createRadialGradient(x, y, 0, x, y, rr * 4);
        g.addColorStop(0, rgba(c, 0.85)); g.addColorStop(0.4, rgba(c, 0.35)); g.addColorStop(1, rgba(c, 0));
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, rr * 4, 0, 6.283); ctx.fill();
        ctx.fillStyle = 'rgba(245,240,232,' + (0.5 * pulse) + ')';
        ctx.beginPath(); ctx.arc(x, y, rr * 0.5, 0, 6.283); ctx.fill();
      }
    }

    var t0 = performance.now();
    var running = true, rafId = null, inView = true, visible = true;
    function tick() { if (running && inView && visible && !reduce) rafId = requestAnimationFrame(frame); }
    function resume() { if (!running) { running = true; tick(); } }
    function pause() { running = false; if (rafId) cancelAnimationFrame(rafId); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        if (inView) resume(); else pause();
      }, { threshold: 0.01 }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () {
      visible = document.visibilityState === 'visible';
      if (visible) resume(); else pause();
    });
    function frame(now) {
      var t = (now - t0) / 1000;
      mx += (tmx - mx) * 0.05; my += (tmy - my) * 0.05;
      autoY += 0.0028;
      rotY += ((mx - 0.5) * 0.9 - rotY) * 0.05;
      rotX += ((my - 0.5) * 0.6 - rotX) * 0.05;
      ctx.clearRect(0, 0, W, H);

      // center soft glow
      var cg = ctx.createRadialGradient(CX, CY, 0, CX, CY, R * 2);
      cg.addColorStop(0, 'rgba(245,240,232,0.10)');
      cg.addColorStop(0.4, 'rgba(196,160,82,0.05)');
      cg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = cg; ctx.fillRect(0, 0, W, H);

      // motes
      for (var i = 0; i < motes.length; i++) {
        var p = motes[i];
        p.x += p.vx + Math.sin(t + p.ph) * 0.15; p.y += p.vy;
        if (p.y < -10) { motes[i] = seedMote(); motes[i].y = H + 10; continue; }
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
        g.addColorStop(0, rgba(p.c, p.a)); g.addColorStop(1, rgba(p.c, 0));
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, 6.283); ctx.fill();
      }

      mandala(t);
      sphere(t);
      orbs(t);

      rafId = null;
      tick();
    }
    tick();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
